import { IDashboardWidgetWithComponent, TDashboardColumn } from 'volta/models/types/user';

import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface IWidgetArgs<T extends Record<string, any> = Record<string, any>> {
  widget: IDashboardWidgetWithComponent<T>;
  column: TDashboardColumn;
  onChange?: (widget: IDashboardWidgetWithComponent, column: TDashboardColumn) => void;
  searchValue: string;
  queryParamsValues: TQueryParams;
}

export default class DashboardWidget extends Component<IWidgetArgs> {
  get widgetComponent() {
    return this.args.widget.component;
  }

  id = `${guidFor(this)}-${this.args.widget.name}`;

  @tracked editWidgetOpened = false;

  @action
  saveWidget([widget]: [IDashboardWidgetWithComponent]) {
    this.args.onChange?.(widget, this.args.column);
    this.editWidgetOpened = false;
  }

  @action
  toggleWidgetActivation(disabled: boolean) {
    const widget = { ...this.args.widget };
    widget.disabled = disabled;

    this.args.onChange?.(widget, this.args.column);
  }
}
